import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import { Environment } from '../../common/interfaces';
import { Decision } from './digital-pricing-bff.types';
import { VBC_EXPERIMENT_OPNAME, VBC_EXPERIMENT_QUERY, PROCESS_ENV_MAP, DIGITAL_PRICING_NET_URLS, DIGITAL_PRICING_GATEWAY_URLS } from './constants';
import { rewriteCheggTldToMatch } from '@chegg/utils';

/**
 * Converts from process.env.CHEGG_ENV to common interfaces Environment
 * @param cheggEnv environment variable
 * @returns Environment
 */
var toCommonEnvironment = function toCommonEnvironment(cheggEnv) {
  return PROCESS_ENV_MAP.get(cheggEnv) || Environment.DEVELOPMENT;
};

/**
 * Returns true if the VBC experiment data represents the RECURLY variatioon
 * @param experimentData VbcExperimentData response from digital-pricing-bff
 * @returns boolean
 */
var getIsVBCVariation = function getIsVBCVariation(experimentData) {
  return (experimentData === null || experimentData === void 0 ? void 0 : experimentData.vbcExperiment.decision) === Decision.RECURLY;
};

/**
 * Checks a GetPricingRequestV2 object for necessary parameters to perform
 * server-side BFF requests, returns true of payload is available
 * @param inputs GetPricingRequestV2
 * @returns boolean
 */
var isInternalRequest = function isInternalRequest(inputs) {
  var _inputs$internalReque;
  if (!((_inputs$internalReque = inputs.internalRequestPayload) !== null && _inputs$internalReque !== void 0 && _inputs$internalReque.passport) || !inputs.internalRequestPayload.pageUrl) return false;
  return true;
};

/**
 * Queries digital-pricing-bff server-side with user passport data, to
 * allocate them to the VBC experiment flag
 * @param environment running application Environment
 * @param inputs GetPricingRequestV2 legacy request format
 * @returns VbcExperimentData | null | undefined
 */
var vbcExperiment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, inputs, hostname) {
    var url, headers, withCredentials, _inputs$internalReque2, passport, pageUrl;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          withCredentials = false;
          if (!inputs.internalRequestPayload || !isInternalRequest(inputs)) {
            url = rewriteCheggTldToMatch(DIGITAL_PRICING_GATEWAY_URLS[environment], hostname);
            headers = {
              'x-chegg-page-url': window.location.href
            };
            withCredentials = true;
          } else {
            url = DIGITAL_PRICING_NET_URLS[environment];
            _inputs$internalReque2 = inputs.internalRequestPayload, passport = _inputs$internalReque2.passport, pageUrl = _inputs$internalReque2.pageUrl;
            headers = {
              'chegg-passport': passport,
              'x-chegg-page-url': pageUrl || ''
            };
          }
          return _context.abrupt("return", vbcExperimentRequest({
            url: url,
            headers: headers,
            withCredentials: withCredentials
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function vbcExperiment(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var vbcExperimentRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var url, headers, withCredentials, body, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = _ref2.url, headers = _ref2.headers, withCredentials = _ref2.withCredentials;
          _context2.prev = 1;
          body = {
            operationName: VBC_EXPERIMENT_OPNAME,
            query: VBC_EXPERIMENT_QUERY,
            variables: {}
          };
          _context2.next = 5;
          return axios.post(url, body, {
            headers: _objectSpread({
              'content-type': 'application/json;charset=UTF-8',
              Accept: 'application/json'
            }, headers),
            withCredentials: withCredentials
          });
        case 5:
          response = _context2.sent;
          return _context2.abrupt("return", response.data.data);
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](1);
          throw _context2.t0;
        case 12:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return function vbcExperimentRequest(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
export { vbcExperiment, getIsVBCVariation, toCommonEnvironment };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/experimentation.util.js
// module id = 1404
// module chunks = 11